import { TableContainer } from "@mui/material";
import React, { FC } from "react";
import { CsobDataSetDataDto } from "@green0meter/api-client";
import { useTranslation } from "react-i18next";

import { HighlightText } from "../HighlightText";
import { InputBoxValue } from "../InputBoxValue";

import {
  Paper,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@components/base";

interface TableQuestionnaire {
  csobDatasetComparison: CsobDataSetDataDto;
}

const TableQuestionnaire: FC<TableQuestionnaire> = ({ csobDatasetComparison }) => {
  const { t } = useTranslation();
  const { questionnaires } = csobDatasetComparison;

  return (
    <TableContainer
      component={Paper}
      variant="outlined"
      sx={{ borderTopLeftRadius: 0, borderTopRightRadius: 0, borderTop: 0 }}
    >
      <Table sx={{ tableLayout: "fixed" }}>
        <TableBody>
          {questionnaires?.map((questionnaire, index) => (
            <React.Fragment key={index}>
              <TableRow key="subtitle1">
                <TableCell colSpan={3} sx={{ background: "#E3F2FD", height: 36 }}>
                  <Typography fontWeight={500} paddingLeft={1}>
                    {questionnaire.name}
                  </Typography>
                </TableCell>
              </TableRow>
              {questionnaire.sections.map((section) => (
                <React.Fragment key={section.sectionIndex}>
                  <TableRow
                    key={section.sectionIndex}
                    sx={{ background: "#F5F5F5 !important", height: 36 }}
                  >
                    <TableCell colSpan={3}>
                      <Typography fontWeight={500} paddingLeft={1}>
                        {section.name}
                      </Typography>
                    </TableCell>
                  </TableRow>
                  {section.answers.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        sx={{ textAlign: "center", paddingY: 2 }}
                      >
                        <Typography variant="body2">
                          {t("csob.datasetComparison.table.noData")}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                  {section.answers.map((answer) => (
                    <TableRow key={answer.questionInternalId} sx={{ height: 44 }}>
                      <TableCell sx={{ paddingY: 1.5 }}>
                        <Typography>{answer.question}</Typography>
                      </TableCell>
                      <TableCell sx={{ paddingY: 1.5 }}>
                        {answer && answer.unit && (
                          <InputBoxValue answer={answer} answerIndex="answer1" />
                        )}
                        {!answer.unit && (
                          <HighlightText
                            isHighlighted={answer.answer1 !== answer.answer2}
                          >
                            {answer.answer1}
                          </HighlightText>
                        )}
                      </TableCell>
                      <TableCell sx={{ paddingY: 1.5 }}>
                        {answer && answer.unit && (
                          <InputBoxValue answer={answer} answerIndex="answer2" />
                        )}
                        {!answer.unit && (
                          <HighlightText
                            isHighlighted={answer.answer1 !== answer.answer2}
                          >
                            {answer.answer2}
                          </HighlightText>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableQuestionnaire;
